import {
  isdeletedFieldName,
  opidFieldName,
  showpublicFieldName,
} from "../../../../utils/API";
import { dangerColor } from "../../../../utils/Theme";

export const getFieldDefaultValue = (f, config) => {
  if (f.name === "iso3" || f.name === "iso3a") {
    return config.iso3
      ? Array.isArray(config.iso3)
        ? config.iso3[0]
        : config.iso3
      : "";
  } else if (f.name === opidFieldName) {
    return config.id;
  } else if (f.name === isdeletedFieldName || f.name === showpublicFieldName) {
    return 2;
  } else if (f.defaultValue) return f.defaultValue;
};

export const LAYER_EFFECT = "grayscale(20%) opacity(13%)";

export const EditType = {
  edit: "edit",
  create: "create",
  delete: "delete",
};

export const pointSymbol = {
  type: "simple-marker",
  size: 8,
  color: dangerColor,
  outline: {
    width: 1,
    color: "#FFF",
  },
};

export const fillSymbol = {
  type: "simple-fill",
  color: dangerColor,
  style: "solid",
  outline: { color: "black", width: 1 },
};

export const pointGraphicSymbol = {
  type: "simple-marker",
  size: 14,
  color: "rgb(192, 58, 43)",
  outline: {
    width: 2,
    color: "#FFF",
  },
};

export const ALL_STEPS = {
  selectLayer: "selectLayer",
  entryPoints: "entryPoints",
  aerodromeType: "aerodromeType",
  aerodromeClass: "aerodromeClass",
  annotations: "annotations",
  enterRoadsSituationalCoordinates: "enterRoadsSituationalCoordinates",
  roadsSituationalManual: "roadsSituationalManual",
  selectLocation: "selectLocation",
  fillFields: "fillFields",
};
